// extracted by mini-css-extract-plugin
export default {"header":"Header_header__XrJaN","middleBox":"Header_middleBox__44DMJ","left_wrap":"Header_left_wrap__v+1mr","logoBox":"Header_logoBox__cRMmJ"};